<template>
  <v-container class="fill-height">
    <v-row v-if="apartmentContent">
      <v-col md="10" offset-md="1">
        <v-alert type="success" v-if="success">
          Apartment successfully created
        </v-alert>
        <v-alert type="error" v-if="error">
          Something went wrong. Please check the developer console!
        </v-alert>
        <v-tabs v-model="languageTab" background-color="transparent">
          <v-tab v-for="language in languages" :key="language.code" :href="'#' + language.code">
            {{ language.name }}
          </v-tab>
        </v-tabs>
        <v-form @submit.prevent="handleSubmit" id="apartment-create-form" class="apartment-create-form" ref="createApartmentForm" v-model="isValid">
          <div v-for="language in languages" :key="language.code" v-show="language.code === languageTab">
              <v-row>
              <v-col md="4">
                <v-autocomplete v-model="selectedBuilding" class="building-autocomplete" prepend-icon="mdi-office-building" :items="getAutocompleteValues(buildings)" label="Изберете сграда" :rules="[rules.required]" required />
              </v-col>
              <v-col md="4" v-if="selectedBuilding">
                <v-autocomplete v-model="selectedEntrance" class="building-autocomplete" prepend-icon="mdi-office-building" :items="getAutocompleteValues(entrances)" label="Изберете вход" :rules="[rules.required]" required />
              </v-col>
              <v-col md="4" v-if="selectedBuilding && selectedEntrance">
                <v-autocomplete v-model="selectedFloor" class="building-autocomplete" prepend-icon="mdi-office-building" :items="getAutocompleteValues(floors)" label="Изберете етаж" :rules="[rules.required]" required />
              </v-col>
            </v-row>
              <v-row>
                <v-col md="4">
                  <v-text-field name="title" prepend-icon="mdi-pencil" label="Заглавие" v-model="apartmentContent[language.code].title" :rules="[rules.required]" required></v-text-field>
                </v-col>
                <v-col md="4">
                  <v-text-field name="title" prepend-icon="mdi-currency-usd" label="Цена" v-model="price" :rules="[rules.required, rules.number]" required></v-text-field>
                </v-col>
                <v-col md="4">
                  <v-text-field name="title" prepend-icon="mdi-currency-usd" label="Цена на квадрат" v-model="pricePerSquare" :rules="[rules.required, rules.number]" required></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="4">
                  <v-text-field name="title" prepend-icon="mdi-textarea" label="Total area" v-model="totalArea" :rules="[rules.required, rules.number]" required></v-text-field>
                </v-col>
                <v-col md="4">
                  <v-text-field name="title" prepend-icon="mdi-textarea" label="Living Area" v-model="livingArea" :rules="[rules.required, rules.number]" required></v-text-field>
                </v-col>
                <v-col md="4">
                  <v-text-field name="title" prepend-icon="mdi-compass" label="Изложение" v-model="apartmentContent[language.code].exhibition" :rules="[rules.required]" required></v-text-field>
                </v-col>
              </v-row>
              <vue-editor placeholder="Описание" v-model="apartmentContent[language.code].description" />
              <v-row>
              <v-col md="12">
                <v-textarea prepend-icon="mdi-map-marker-path" v-model="coordinates" name="coordinates" label="Координати"></v-textarea>
              </v-col>
            </v-row>
              <v-row>
                <v-col md="4">
                  <v-select :items="statuses" prepend-icon="mdi-help-circle" item-text="state" item-value="abbr" label="Статус" v-model="status" :rules="[rules.required]" required></v-select>
                </v-col>
                <v-col md="4">
                  <v-file-input
                    accept="image/png, image/jpeg, image/bmp"
                    prepend-icon="mdi-file-image"
                    label="Изображение"
                    v-model="image"
                  ></v-file-input>
                </v-col>
                <v-col md="4">
                  <v-text-field name="apartment" prepend-icon="mdi-office-building" label="Вид на имота" v-model="apartmentContent[language.code].type" :rules="[rules.required]" required></v-text-field>
                </v-col>
              </v-row>
              <v-expansion-panels v-model="seoPanel" multiple>
                <v-expansion-panel>
                  <v-expansion-panel-header>SEO</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col md="6">
                        <v-text-field name="slug" prepend-icon="mdi-pencil" label="Слъг" v-model="apartmentContent[language.code].slug" :rules="[rules.required]" required></v-text-field>
                      </v-col>
                      <v-col md="6">
                        <v-text-field name="seo_title" prepend-icon="mdi-pencil" label="Заглавие" v-model="apartmentContent[language.code].seoTitle"></v-text-field>
                      </v-col>
                      <v-col md="12">
                        <v-text-field name="seo_description" prepend-icon="mdi-pencil" label="Описание" v-model="apartmentContent[language.code].seoDescription"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <v-row>
                <v-col md="3">
                  <v-switch value label="Мезонет" color="indigo" v-model="maisonette"></v-switch>
                </v-col>
                <v-col md="3">
                  <v-switch value label="Апартамент на Бокал" color="indigo" v-model="isBokalApartment"></v-switch>
                </v-col>
              </v-row>
          </div>
        </v-form>
        <v-btn color="success" type="submit" form="apartment-create-form">Запиши</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { uploadImage } from '@/repositories/upload.repository'
import { createApartment } from '@/repositories/apartment.repository'
export default {
  data () {
    return {
      image: null,
      status: null,
      totalArea: 0,
      livingArea: 0,
      exhibition: null,
      maisonette: false,
      isBokalApartment: false,
      pricePerSquare: 0.0,
      price: 0.0,
      coordinates: null,
      seoPanel: [0, 1],
      isValid: false,
      languageTab: null,
      apartmentContent: null,
      selectedBuilding: null,
      selectedEntrance: null,
      selectedFloor: null,
      statuses: [
        { state: 'Свободен', abbr: 1 },
        { state: 'Продаден', abbr: 3 },
        { state: 'Резервиран', abbr: 2 }
      ],
      rules: {
        required: value => !!value || 'Това поле е задължително!',
        number: value => /^\d*\.?\d*$/.test(value) || 'Цената трябва да е число'
      },
      success: false,
      error: false
    }
  },
  created () {
    this.$store.dispatch('fetchLanguages')
      .then(() => {
        this.apartmentContent = {};
        for (const language of this.languages) {
          this.apartmentContent[language.code] = {
            title: null,
            description: null,
            exhibition: null,
            seoTitle: null,
            seoDescription: null,
            slug: null,
            type: null
          };
        }
      })

    this.$store.dispatch('fetchBuildings')
    this.$store.dispatch('fetchEntrances')
    this.$store.dispatch('fetchFloors')
  },
  computed: {
    languages () {
      return this.$store.state.language.languages
    },
    buildings () {
      return this.$store.state.building.buildings
    },
    entrances () {
      return this.$store.state.entrance.entrances
    },
    floors () {
      return this.$store.state.floor.floors
    },
    buildingsAutocompleteValues () {
      const buildings = [...this.buildings]
      return buildings.map(building => ({
        text: building.translations ? building.translations.title : '',
        value: building.id
      }))
    }
  },
  methods: {
    getAutocompleteValues (objectData) {
        const data = objectData
        return data.map(d => ({
            text: d.translations ? d.translations.title : '',
            value: d.id
        }))
    },
    handleSubmit () {
      this.success = false
      this.error = false

      this.$refs.createApartmentForm.validate();
      if (!this.isValid) {
        return
      }

      if (!this.image) {
        this.apartmentCreate()
        this.scrollToTop()
        return
      }

      this.uploadImage()
      this.scrollToTop()
    },
    uploadImage () {
      const formData = new FormData()
      formData.append('file', this.image)

      try {
        uploadImage(formData)
          .then(res => {
            this.apartmentCreate(res.data.file)
          }).catch(error => {
            console.log(error)
            this.error = true
            this.success = false
          })
      } catch (e) {
        console.log(e)
        this.error = true
        this.success = false
      }
    },
    apartmentCreate (image = null) {
      const apartmentData = {
        status: this.status,
        coordinates: this.coordinates,
        totalArea: +this.totalArea,
        livingArea: +this.livingArea,
        price: +this.price,
        pricePerSquare: +this.pricePerSquare,
        maisonette: this.maisonette,
        isBokalApartment: this.isBokalApartment,
        floorId: this.selectedFloor,
        entranceId: this.selectedEntrance,
        buildingId: this.selectedBuilding,
        image,
        ...this.apartmentContent
      }

      try {
        createApartment(apartmentData)
          .then(response => {
            const { success } = response.data
            this.success = success
            this.error = !this.success

            this.reset()
          }).catch(error => {
            console.log(error)
            this.error = true
            this.success = false
          })
      } catch (e) {
        console.log(e)
        this.error = true
        this.success = false
      }
    },
    scrollToTop () {
      window.scroll({
        top: 0,
        behavior: 'smooth'
      })
    },
    reset () {
      this.$refs.createApartmentForm.reset()
    }
  }
}
</script>

<style lang="scss">
.v-form.apartment-create-form {
  width: 100%;
}
.ql-container.ql-snow,
.ql-toolbar.ql-snow {
  border-color: rgba(0,0,0,.42);
}
.ql-container.ql-snow {
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}
.ql-toolbar.ql-snow {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.quillWrapper {
  margin-top: 15px;
}
.theme--light.v-tabs-items {
  background: transparent;
}
</style>
